module.exports = __webpack_public_path__ + "img/8.f167b9fa.png";